<template>
  <v-card>
    <v-card-title :class="contractColor">
      <span class="headline">
        {{ $t('editActivities') }}
      </span>
    </v-card-title>

    <v-card-text>
      <v-radio-group v-model="selectedRateChangeMode" class="mt-n5">
        <v-radio :value="ActivityRateChangeMode.Schedule" :disabled="disableSchedule">
          <template #label>
            <v-row dense class="mt-8 mb-n4">
              <v-col cols="12">
                <span>
                  {{ $t('schedule') }}
                </span>
              </v-col>

              <v-col cols="12">
                <span class="body-2 grey--text">
                  {{ $t('scheduleBody') }}
                </span>
              </v-col>

              <v-col cols="12">
                <span class="caption error--text">
                  <slot name="schedule-error-message"></slot>
                </span>
              </v-col>
            </v-row>
          </template>
        </v-radio>

        <v-radio :label="$t('overwrite')" :value="ActivityRateChangeMode.Overwrite">
          <template #label>
            <v-row dense class="mt-8 mb-n4">
              <v-col cols="12">
                <span>
                  {{ $t('overwrite') }}
                </span>
              </v-col>

              <v-col cols="12">
                <span class=" body-2 grey--text">
                  {{ $t('overwriteBody') }}
                </span>
              </v-col>
            </v-row>
          </template>
        </v-radio>
      </v-radio-group>
    </v-card-text>

    <v-card-actions class="pr-0 py-4">
      <v-row justify="end">
        <v-col cols="auto">
          <v-btn :color="contractColor" @click="continueClicked">
            {{ $t('continue') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ActivityRateChangeMode } from '@/components/activity/Activity.js'
import { colorClassForContractType } from '@/utils/componentHelpers.js'

export default {
  name: 'ActivityRateChangeTypeSelectionCard',

  props: {
    disableSchedule: {
      type: Boolean,
      default: false
    },
    contractType: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    ActivityRateChangeMode,
    selectedRateChangeMode: ActivityRateChangeMode.Overwrite
  }),

  created () {
    if (this.disableSchedule) {
      this.selectedRateChangeMode = ActivityRateChangeMode.Overwrite
    }
  },

  computed: {
    contractColor () {
      return colorClassForContractType(this.contractType)
    }
  },

  methods: {
    continueClicked () {
      this.$emit('continue', this.selectedRateChangeMode)
    }
  }
}
</script>
